
export function createPath(title) {
    let result = title.replaceAll(" ", "-").toLowerCase();
  return result
}
